import * as React from 'react'
import { FunctionComponent } from 'react'
import TableContext, {
  createTableContext,
} from '../../../../contexts/TableContext'
import { ReportGroupBy } from '../../../../typings/report'
import ClicksTable from './ClicksTable'

type ClicksSorts = 'clickId' | 'clickDate' | 'productName' | 'subtracking'

type GroupBy = { [key in ReportGroupBy]: string }

interface ClicksFilters extends GroupBy {
  groupBy: string
  dateType: string
  startDate: string
  endDate: string
}

export const ClicksTableContext = createTableContext<
  ClicksFilters,
  ClicksSorts
>()

const ClicksReport: FunctionComponent = () => {
  return (
    <TableContext<ClicksFilters, ClicksSorts>
      Context={ClicksTableContext}
      queryParams={[
        'dateType',
        'endDate',
        'startDate',
        'productType',
        'product',
        'category',
        'advertiser',
        'subtracking',
      ]}
    >
      <ClicksTable />
    </TableContext>
  )
}

export default ClicksReport
